import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Typography, Select, MenuItem } from '@material-ui/core';
import { Button } from '@fifth-gear-tech/common-components/dist/components';
import { ButtonType } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';

import utils from '../../utils';

const ColorBandSelector = ({ colors, setColorBand }) => {
    const [selectedColorsId, setSelectedColorsId] = useState(null);
    const [colorBandValue, setColorBandValue] = useState(null);

    const handleColorBandSelected = (value, items) => {
        setColorBandValue(value);
        const { label } = items.find((i) => i.value == value);
        setColorBand([{ label, style: { backgroundColor: `#${value}`, color: utils.color.isLight(value) ? '#000' : '#FFF' } }]);
    };

    const resetColorBand = () => {
        setSelectedColorsId(null);
        setColorBandValue(null);
        setColorBand([]);
    };

    const possibleColors = colors.find((c) => c?.id == selectedColorsId);

    return (
        <div>
            <div style={{ width: '75%', marginTop: '2rem', marginBottom: '1rem' }}>
                <Typography variant='subtitle1' style={{ fontWeight: '600' }}>Select Color Band (Optional)</Typography>

                {/* select color template */}
                <Select style={{ width: '100%', border: '1px solid gray', borderRadius: '5px' }} placeholder='Select Color' value={selectedColorsId} onChange={(e) => setSelectedColorsId(e.target.value)}>
                    {colors.map((c) => <MenuItem key={c?.id} value={c?.id}>{c?.name}</MenuItem>)}
                </Select>

                {/* select color band */}
                {(selectedColorsId && possibleColors?.json_data?.items?.length > 0) &&
                    <div style={{ marginTop: '1rem' }}>
                        <Select style={{ width: '100%', border: '1px solid gray', borderRadius: '5px' }} placeholder='Select Color' value={colorBandValue} onChange={(e) => handleColorBandSelected(e.target.value, possibleColors?.json_data?.items)}>
                            {possibleColors?.json_data?.items?.map((c) => (
                                <MenuItem key={c?.value} value={c?.value} name={c?.label}>{c?.label}</MenuItem>
                            ))}
                        </Select>
                    </div>
                }
            </div>
            <Button type={ButtonType.Reset} label={'Reset Color band'} onClick={resetColorBand} />
        </div>
    );
};

ColorBandSelector.propTypes = {
    colors: PropTypes.array,
    setColorBand: PropTypes.func
};

export default ColorBandSelector;